import { BaseWidgetRenderer } from './base-widget-renderer';
import { SubmitWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';
import { HtmlUtils } from '../../utils/html.utils';

export class SubmitWidgetRenderer extends BaseWidgetRenderer<SubmitWidgetJsonData> {
    protected override get defaultData(): SubmitWidgetJsonData {
        return {
            id: '',
            type: 'submit',
            variant: 'simple',
            submitLabel: TranslateUtils.SUBMIT_WIDGET.LABEL,
            previousLabel: TranslateUtils.SUBMIT_WIDGET.PREVIOUS_LABEL,
            nextLabel: TranslateUtils.SUBMIT_WIDGET.NEXT_LABEL,
            height: '40px'
        };
    }

    public override createNew(options?: WidgetRenderOptions & { isExtendedVariant?: boolean }): HTMLElement {
        const defaultData = super.createDefaultData();

        if (options?.isExtendedVariant) {
            defaultData.variant = 'extended';
        }

        return this.render(defaultData, options);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: SubmitWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const isExtended = widgetJsonData.variant?.toLowerCase() === 'extended';
        if (isExtended) {
            if (widgetJsonData.previousLabel !== null && widgetJsonData.previousLabel !== undefined) {
                const prevButton = this.createButton('previous', widgetJsonData.previousLabel || TranslateUtils.SUBMIT_WIDGET.PREVIOUS_LABEL);
                content.appendChild(prevButton);
            }

            if (widgetJsonData.nextLabel !== null && widgetJsonData.nextLabel !== undefined) {
                const nextButton = this.createButton('next', widgetJsonData.nextLabel || TranslateUtils.SUBMIT_WIDGET.NEXT_LABEL);
                content.appendChild(nextButton);
            }

            if (widgetJsonData.submitLabel !== null && widgetJsonData.submitLabel !== undefined) {
                const submitButton = this.createButton('submit', widgetJsonData.submitLabel || TranslateUtils.SUBMIT_WIDGET.LABEL, 'submit');
                content.appendChild(submitButton);
            }
        } else {
            const submitButton = this.createButton('submit', widgetJsonData.submitLabel || TranslateUtils.SUBMIT_WIDGET.LABEL, 'submit');
            content.appendChild(submitButton);
        }

        return content;
    }

    private createButton(variant: string, label: string, type: 'button' | 'submit' = 'button'): HTMLElement {
        const button = document.createElement('button');
        button.classList.add('button-element', `button-element--${variant}`);
        button.type = type;

        const labelSpan = document.createElement('span');
        labelSpan.classList.add('button-label');
        labelSpan.innerHTML = HtmlUtils.sanitize(label);

        button.appendChild(labelSpan);

        return button;
    }

    protected override applyAdditionalAttributes(element: HTMLElement, widgetJsonData: SubmitWidgetJsonData): void {
        super.applyAdditionalAttributes(element, widgetJsonData);

        element.dataset['group'] = 'buttons';

        if (widgetJsonData.variant?.toLowerCase() === 'extended') {
            element.dataset['variant'] = 'extended';
        }

        element.style.height = widgetJsonData.height;
    }
}
